import { apiInstance } from '../api';
import { curatorRoute } from "./curator.route";

export class CuratorService {
  static async fetchCurators() {
    return apiInstance.get(curatorRoute);
  }

  static async createCurator(curatorInfo) {
    return apiInstance.post(curatorRoute, curatorInfo, {
      params: { headers: { 'Content-Type': 'multipart/form-data' } }
    });
  }

  static async updateCuratorInfo(curatorId, updatedCuratorInfo) {
    return apiInstance.put(`${curatorRoute}/${curatorId}`, updatedCuratorInfo, {
      params: { headers: { 'Content-Type': 'multipart/form-data' } }
    });
  }

  static async deleteCurator(curatorId) {
    return apiInstance.delete(`${curatorRoute}/${curatorId}`);
  }
}
